import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Icon } from './Icons';

/**
 * 얇은 서브 메뉴 컴포넌트
 * @param {Array} items - 메뉴 아이템 배열 [{ path, label, icon, external }]
 * @param {string} basePath - 기본 경로 (선택사항)
 */
const SubMenu = ({ items, basePath = '' }) => {
  const location = useLocation();

  // 공통 스타일 클래스
  const navClass = "bg-white dark:bg-[#2c2c2e] border-b border-black/[0.06] dark:border-white/10 sticky top-[44px] z-[1]";

  const innerClass = "max-w-[980px] mx-auto pl-[44px] pr-[22px] flex justify-start gap-1 overflow-x-auto scrollbar-none max-md:pl-6 max-md:pr-4";

  const getItemClass = (isActive) => `
    flex items-center gap-1.5 py-2.5 px-4 text-xs font-normal text-[#1d1d1f] dark:text-white/85
    no-underline whitespace-nowrap rounded-full transition-all duration-200
    border-none bg-transparent
    hover:text-[#1d1d1f] hover:bg-black/[0.06] dark:hover:text-white dark:hover:bg-white/[0.08]
    max-md:py-2.5 max-md:px-3.5 max-md:text-[13px]
    ${isActive ? 'font-medium bg-black/[0.06] dark:text-white dark:bg-white/[0.12]' : ''}
  `.trim().replace(/\s+/g, ' ');

  const getIconClass = (isActive) => `
    inline-flex items-center justify-center flex-shrink-0
    ${isActive ? 'opacity-100' : 'opacity-70'}
    group-hover:opacity-100
  `.trim().replace(/\s+/g, ' ');

  return (
    <nav className={navClass}>
      <div className={innerClass}>
        {items.map((item) => {
          const fullPath = basePath ? `${basePath}${item.path}` : item.path;
          const isActive = location.pathname === fullPath ||
                          (item.path === '/' && location.pathname === basePath) ||
                          (item.external && location.pathname.startsWith(item.path));

          // 외부 링크 (같은 도메인 내 다른 앱)
          if (item.external) {
            return (
              <a
                key={item.path}
                href={item.path}
                className={`group ${getItemClass(isActive)}`}
              >
                {item.icon && <Icon name={item.icon} size={16} className={getIconClass(isActive)} />}
                <span className="leading-none">{item.label}</span>
              </a>
            );
          }

          return (
            <NavLink
              key={item.path}
              to={fullPath}
              className={`group ${getItemClass(isActive)}`}
            >
              {item.icon && <Icon name={item.icon} size={16} className={getIconClass(isActive)} />}
              <span className="leading-none">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default SubMenu;
